import { useEffect, useMemo, useState } from 'react';
import { preloadImage } from '../utils/imagePreload';

const normalizeSources = (sources = []) => [
  ...new Set(
    (sources || []).filter(Boolean).map((source) => String(source).trim())
  ),
];

export const useImagePreload = (sources = []) => {
  const normalizedSources = useMemo(() => normalizeSources(sources), [sources]);
  const [isReady, setIsReady] = useState(normalizedSources.length === 0);

  useEffect(() => {
    let isMounted = true;

    if (!normalizedSources.length) {
      setIsReady(true);
      return () => {
        isMounted = false;
      };
    }

    setIsReady(false);

    Promise.all(normalizedSources.map((source) => preloadImage(source)))
      .catch(() => [])
      .finally(() => {
        if (isMounted) {
          setIsReady(true);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [normalizedSources]);

  return isReady;
};
